import { createFileRoute } from '@tanstack/react-router';

import { CwfCarePlanDocumentPage } from '@/pages/blood-report/documents/cwf';

export const Route = createFileRoute(
  '/blood-report/_role-guard/$id/documents/cwf/care-activity/$careActivityId/$typeId',
)({
  component: CwfCarePlanDocumentPage,
});
